// src/components/admin/scheduling/components/EventCard.js
import React from "react";
import "./EventCard.css";
import { formatTimeFromMinutes } from "../timeUtils";

export default function EventCard({ event, onClick, onDoubleClick, isSelected }) {
  const timeLabel = `${formatTimeFromMinutes(event.startTime)} – ${formatTimeFromMinutes(event.endTime)}`;
  const classes = [
    "eventCard",
    isSelected ? "eventCard--selected" : "",
    event.recurrence?.enabled ? "eventCard--recurring" : "",
    event.syncStatus === "sync_failed" ? "eventCard--syncFailed" : "",
  ].filter(Boolean).join(" ");

  return (
    <div
      className={classes}
      onClick={(e) => { e.stopPropagation(); onClick?.(event); }}
      onDoubleClick={(e) => { e.stopPropagation(); onDoubleClick?.(event); }}
      title={event.notes ? `${event.title}\n${event.notes}` : event.title}
    >
      <div className="eventCard__title">{event.title}</div>
      <div className="eventCard__time">{timeLabel}</div>
    </div>
  );
}
